import Profile from "../myPages/myAuth/Profile";
import CreateSubscriptionPackage from "../myPages/SubscriptionPackages/CreateSubscriptionPackage";
import ViewSubscriptionPackages from "../myPages/SubscriptionPackages/ViewSubscriptionPackages";
import ViewTransactions from "../myPages/SubscriptionPackages/ViewTransactions";

import ViewDeals from "../myPages/DealsSection/ViewDeals";
import AllCustomers from "../myPages/myCutomers/AllCustomers";
import AllBlockCustomers from "../myPages/myCutomers/AllBlockCustomers";
import Banners from "../myPages/myBanners/ViewBanners";
import SendDeals from "../myPages/DealsSection/SendDeals";
import CreateDeal from "../myPages/DealsSection/CreateDeal";
import ViewFaqs from "../myPages/myFaqs/ViewFaqs";
import CreateFaqs from "../myPages/myFaqs/CreateFaqs";
import ViewBanners from "../myPages/myBanners/ViewBanners";
import CreateBanner from "../myPages/myBanners/CreateBanner";
import Dashboard from "../myPages/Dashboard";
import DealsInquiry from "../myPages/DealsSection/comp/DealsInquiry";
import Call from "../myPages/Call";
import WebsiteInquiry from "../myPages/WebsiteInquiry";
import CRM from "../myPages/CRM";
import ViewMore from "../myPages/DealsSection/comp/ViewMore";
import UpcomingCall from "../myPages/Call/UpcomingCall";
import Inquiry from "../myPages/DealsSection/comp/Inquiry";
import UserDetails from "../myPages/myCutomers/UserDetails";
import History from "../myPages/Call/History";
import ForgetPassword from "../myPages/myAuth/ForgetPassword";
import VerifyOTP from "../myPages/myAuth/VerifyOtp";
import ResetNewPassword from "../myPages/myAuth/ResetNewPassword";
import NewAdmin from "../myPages/Admin/NewAdmin.jsx";
import AllAdmin from "../myPages/Admin/AllAdmin.jsx";
import DailyProgram from "../myPages/Programs/DailyProgram.jsx";
import WorkoutProgram from "../myPages/Programs/WorkoutProgram.jsx";
import ChallengesProgram from "../myPages/Programs/ChallengesProgram.jsx";
import SingleProgram from "../myPages/Programs/SingleProgram.jsx";
import ViewPrograms from "../myPages/Programs/ViewPrograms.jsx";
import Reports from "../myPages/community/Reports.jsx";
import AllMembers from "../myPages/myCutomers/AllMembers.jsx";
import BlockedAdmins from "../myPages/Admin/BlockedAdmins.jsx";
import UploadTutorials from "../myPages/Admin/UploadTutorials.jsx";
import Terms from "../myPages/Admin/Terms.jsx";
import Orders from "../myPages/Admin/Orders.jsx";
import Tasks from "../myPages/Admin/Tasks.jsx";
import Error404 from "../Components/Pages/ErrorPages/ErrorPage404.jsx";
import Zips from "../myPages/Admin/Zips.jsx";

export const routes = [
  {
    path: '*',
    Component: <Error404 />,
  },
  {
    path: `/dashboard`,
    Component: <Dashboard />,
  },
  {
    path: `/tasks`,
    Component: <Tasks />,
  },
  {
    path: `/forget-password`,
    Component: <ForgetPassword />,
  },
  {
    path: `/verify-otp`,
    Component: <VerifyOTP />,
  },
  {
    path: `/reset-new-password`,
    Component: <ResetNewPassword />,
  },
  {
    path: `/crm`,
    Component: <CRM />,
  },
  {
    path: `/users/all-customers`,
    Component: <AllCustomers />,
  },
  {
    path: `/users/all-block-customers`,
    Component: <AllBlockCustomers />,
  },
  {
    path: `/tutorials`,
    Component: <UploadTutorials />,
  },
  {
    path: `/all-members`,
    Component: <AllMembers />,
  },
  {
    path: `/terms`,
    Component: <Terms />,
  },
  {
    path: `/zips`,
    Component: <Zips />,
  },
  {
    path: `/orders`,
    Component: <Orders />,
  },
  { path: "/user-details/:id", Component: <UserDetails /> },
  // {
  //   path: `/user/:id`,
  //   Component: <SingleCustomer />,
  // },
  {
    path: `/account/profile`,
    Component: <Profile />,
  },

  {
    path: `/advertisement-banner`,
    Component: <Banners />,
  },
  {
    path: `/create-admin`,
    Component: <NewAdmin />,
  },
  {
    path: `/admin`,
    Component: <AllAdmin />,
  },
  {
    path: `/block-subAdmins`,
    Component: <BlockedAdmins />,
  },
  {
    path: `/create-add`,
    Component: <Banners />,
  },
  {
    path: `/create-ovah-products`,
    Component: <Banners />,
  },
  {
    path: `/adds`,
    Component: <Banners />,
  },
  {
    path: `/ovah-products`,
    Component: <Banners />,
  },
  {
    path: `/subscription-packages/create`,
    Component: <CreateSubscriptionPackage />,
  },

  {
    path: `/subscription-packages/view`,
    Component: <ViewSubscriptionPackages />,
  },

  {
    path: `/customers/transactions`,
    Component: <ViewTransactions />,
  },
  {
    path: `/members/transactions`,
    Component: <ViewTransactions />,
  },

  {
    path: `/excercise/create`,
    Component: <CreateDeal />,
  },
  {
    path: `/excercise/edit/:id`,
    Component: <CreateDeal />,
  },
  {
    path: `/programs`,
    Component: <ViewPrograms />,
  },
  {
    path: `/programs/daily`,
    Component: <DailyProgram />,
  },
  {
    path: `/programs/workout`,
    Component: <WorkoutProgram />,
  },
  {
    path: `programs/single-excercise`,
    Component: <SingleProgram />,
  },
  {
    path: `/programs/fitness-Challenges`,
    Component: <ChallengesProgram />,
  },
  {
    path: `/excercise/create`,
    Component: <CreateDeal />,
  },
  {
    path: `/programs/daily/:id`,
    Component: <DailyProgram />,
  },
  {
    path: `/programs/workout/:id`,
    Component: <WorkoutProgram />,
  },
  {
    path: `programs/single-exercise/:id`,
    Component: <SingleProgram />,
  },
  {
    path: `/programs/fitness-Challenges/:id`,
    Component: <ChallengesProgram />,
  },
  {
    path: `/excercise/edit/1`,
    Component: <CreateDeal />,
  },
  {
    path: `/deals/send-deals`,
    Component: <SendDeals />,
  },
  {
    path: `/inquiry`,
    Component: <DealsInquiry />,
  },
  {
    path: `/customer/Inquiry`,
    Component: <Inquiry />,
  },
  {
    path: `/deals/1`,
    Component: <ViewMore />,
  },
  {
    path: `/website/Inquiry`,
    Component: <WebsiteInquiry />,
  },

  {
    path: `/schedule-call`,
    Component: <Call />,
  },
  {
    path: `/upcoming-call`,
    Component: <UpcomingCall />,
  },
  {
    path: `/meet/history`,
    Component: <History />,
  },
  {
    path: `/deals/view`,
    Component: <ViewDeals />,
  },
  {
    path: `/excercise/view`,
    Component: <ViewDeals />,
  },
  {
    path: `/faqs/view`,
    Component: <ViewFaqs />,
  },
  {
    path: `/faqs/create`,
    Component: <CreateFaqs />,
  },
  {
    path: `/banners/view`,
    Component: <ViewBanners />,
  },

  {
    path: `/banners/create`,
    Component: <CreateBanner />,
  },
];
